<template>
  <div class="settings scrollbar">
    <span class="header">Create Coupons</span>
    <div class="row mt-4">
      <label class="label">Name</label>
      <div class="value">
        <input
          v-model="name"
          class="select"
          placeholder="Coupon name"
          type="text"
        >
      </div>
    </div>
    <div class="row mt-4">
      <label class="label required">Code</label>
      <div class="value">
        <input
          v-model="code"
          class="select"
          placeholder="STUDIO2025"
          type="text"
        >
      </div>
    </div>
    <div class="row mt-4">
      <label class="label required">Amount ($)</label>
      <div class="value">
        <input
          v-model="amount"
          class="select"
          type="number"
          min="0"
        >
      </div>
    </div>
    <div class="row mt-4">
      <label class="label">Num Uses</label>
      <div class="value">
        <input
          v-model="numUses"
          class="select"
          type="number"
        >
      </div>
    </div>
    <div class="row mt-4">
      <label class="label required">Program</label>
      <div class="value">
        <input
          v-model="program"
          class="select"
          placeholder="Studio Promotion 2025"
          type="text"
        >
      </div>
    </div>
    <div class="row mt-4">
      <label class="label">Description</label>
      <div class="value">
        <input
          v-model="description"
          class="select"
          type="text"
        >
      </div>
    </div>
    <div class="row mt-4">
      <label class="label required">Expiry Date</label>
      <div class="value d-flex align-items-center">
        <input
          v-model="expiryDate"
          class="select"
          type="text"
          placeholder="mm/dd/yyyy"
          @input="formatDate"
        >
      </div>
    </div>
    <div class="row mt-4">
      <label class="label">Emails</label>
      <div class="value">
        <textarea
          v-model="emails"
          class="select"
          placeholder="Comma separated e-mails"
          rows="20"
          cols="50"
        />
      </div>
    </div>
    <div class="row mt-3 footer">
      <button class="button button-sm rounded" @click.stop="addCoupon">Create</button>
    </div>
  </div>
</template>

<script>
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import { useToast } from 'vue-toast-notification';

const $toast = useToast();

export default {
  name: 'CreateCoupon',
  components: {
  },
  data() {
    return {
      dsConn: new DatastoreConnect(this.$store.state.enterpriseServerUrl),
      name: null,
      errorName: false,
      isError: false,
      code: null,
      amount: null,
      program: null,
      description: null,
      emails: null,
      expiryDate: null,
      menu: null,
      numUses: null,
    };
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
    isSuper() {
      return this.user && (this.user.role === 'super');
    },
    minDateFormatted() {
      const currentDate = new Date();
      const year = currentDate.getUTCFullYear();
      const month = String(currentDate.getUTCMonth() + 1).padStart(2, '0'); // Months are zero-indexed
      const day = String(currentDate.getUTCDate()).padStart(2, '0');
      const formattedDate = `${year}-${month}-${day}`;
      return formattedDate;
    },
  },
  created() {
    if (!this.isSuper) {
      this.$router.push({ path: '/login' });
    }
  },
  methods: {
    formatDate() {
      let v = this.expiryDate.replace(/\D/g, ''); // Remove non-digits
      if (v.length > 2) v = `${v.slice(0, 2)}/${v.slice(2)}`;
      if (v.length > 5) v = `${v.slice(0, 5)}/${v.slice(5, 9)}`;
      this.expiryDate = v.slice(0, 10); // Limit to dd/mm/yyyy
    },
    async addCoupon() {
      if (!this.code) {
        $toast.open({
          queue: true,
          duration: 5000,
          message: `Missing code`,
          type: "error",
          position: "top",
        });
        return;
      }
      if (!this.amount) {
        $toast.open({
          queue: true,
          duration: 5000,
          message: `Missing coupon amount`,
          type: "error",
          position: "top",
        });
        return;
      }
      if (!this.program) {
        $toast.open({
          queue: true,
          duration: 5000,
          message: `Missing program name`,
          type: "error",
          position: "top",
        });
        return;
      }
      if (!this.expiryDate) {
        $toast.open({
          queue: true,
          duration: 5000,
          message: `Missing expiry date`,
          type: "error",
          position: "top",
        });
        return;
      }
      let emailList = [];
      if (this.emails && this.emails !== "") {
        emailList = this.emails.split(",");
      }
      emailList = emailList.map((e) => e.trim()).filter((e) => e !== "");

      const params = {
        coupon_name: this.name,
        amount: this.amount,
        coupon_code: this.code,
        program: this.program,
        description: this.description,
        expiry: this.expiryDate,
        emails: emailList,
        num_usage: this.numUses,
      };
      await this.dsConn.addCoupon(params)
        .then((data) => {
          if (data.result) {
            $toast.open({
              queue: true,
              duration: 5000,
              message: `Coupon added successfully.`,
              type: "success",
              position: "top",
            });
          } else if (data.error) {
            $toast.open({
              queue: true,
              duration: 5000,
              message: `${data.error.message}`,
              type: "error",
              position: "top",
            });
          }
        })
        .catch((e) => {
          $toast.open({
            queue: true,
            duration: 5000,
            message: `${e}`,
            type: "error",
            position: "top",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.settings {
  display: flex;
  flex-direction: column;
  width: 600px;
  min-width: 400px;
  height: 100%;
  padding: 30px;
  overflow-y: auto;
}

.header {
  font-size: 1.2rem;
  font-weight: 700;
}

.row {
  flex-wrap: nowrap !important;
}

.row > .label {
  display: flex;
  justify-content: end;
  align-items: center;
  width: 200px;
  text-align: right;
  font-size: 0.9rem;
  font-weight: 600;
  color: rgba(grey, 0.9);

  &.required::after {
    content: '*';
    font-size: 14px;
    font-weight: 700;
    padding-left: 1px;
    @include themify() {
      color: themed('color-primary');
    }
  }
}

.row > .value {
  flex: 1 1 auto;
  font-size: 0.9rem;
  margin-left: 20px;
}

.select {
  width: 100%;
  height: 30px;
  border-radius: 5px;
  font-size: 1rem;
  padding: 3px 10px;
  align-self: center;
  -webkit-appearance: auto;
  background: rgba(#ffffff, 0.8);
  @include themify() {
    border: 1px solid themed('form-input-border');
  }

}

.select:focus {
  @include themify() {
    border: 1px solid themed('color-primary');
    box-shadow:  0 0 0 1px themed('color-primary'), 0 0 3px themed('color-primary-300');
  }
  outline: 2px solid transparent;
  outline-offset: 2px;
}

input.error , select.error {
  @include themify() {
    border: 1px solid themed('color-red') !important;
    box-shadow:  0 0 0 1px themed('color-red'), 0 0 3px themed('color-red') !important;
  }

  &:focus, &:focus-visible {
    @include themify() {
      border: 1px solid themed('color-red') !important;
      box-shadow:  0 0 0 1px themed('color-red'), 0 0 3px themed('color-red') !important;
    }
  }
}

.error-text {
  color: $color-red-500;
}

.success-text {
  color: $color-success;
}

.footer {
  display: flex;
  justify-content: flex-end;
  margin-right: 1px;
  button {
    width: fit-content
  }
  span {
    color: $color-link;
    text-decoration: underline;
    cursor: pointer;
    width: fit-content;
  }
}
</style>
